import React, { useState } from "react";
import { string, any, bool, func } from "prop-types";
import * as style from "./styles.module.scss";
import { getStatus } from "../../../helpers";
import ErrorIcon from "../../../icons/ErrorIcon";
import OverflowedText from "../../../common/OverflowedText";
import { triggerDownload } from "../../../common/OnboardingSectionCreator/helpers";
import LoadingSpinner from "../../../icons/LoadingSpinner";

const getButtonForSection = (
  section,
  isIncomplete = false,
  action,
  customText = "",
  redOutline = false,
  disabled = false
) => {
  // for downloads
  const [curTypeCode, setCurTypeCode] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const getCustomText = () => (disabled ? "Pending" : customText);

  const isCustom = customText !== "";
  if (isIncomplete || isCustom || redOutline) {
    return (
      <button
        disabled={disabled}
        className={`btn btn-primary ${style.profile__profileItem_button} ${
          isCustom && style.profile__profileItem_button_custom
        }`}
        onClick={
          section.onClick
            ? () => section.onClick()
            : () => action(section.taskName, section.link)
        }
      >
        {isCustom ? getCustomText() : "Add"}
      </button>
    );
  }

  if (section.isDownload && section.status === 1) {
    return (
      <button
        className={`btn font-weight-bold text-dark btn-outline-info ${style.profile__profileItem_button}`}
        onClick={() => {
          const { typeCode, fileName } = section;
          setLoading(true);
          setCurTypeCode(typeCode);
          triggerDownload(
            typeCode,
            fileName || "Stronger Together.pdf",
            setCurTypeCode,
            setLoading
          );
        }}
      >
        {section.typeCode === curTypeCode && loading ? (
          <LoadingSpinner />
        ) : (
          "Download"
        )}
      </button>
    );
  }
  return (
    <button
      className={`btn font-weight-bold text-dark btn-outline-info ${style.profile__profileItem_button}`}
      onClick={
        section.onClick
          ? () => section.onClick()
          : () => action(section.taskName, section.link)
      }
    >
      {section.buttonText || section.updateable === false ? "View" : "Update"}
    </button>
  );
};

getButtonForSection.propTypes = {
  className: string,
};

const ProfileItem = ({
  item,
  isIncomplete = false,
  onAddOrUpdate,
  customText = "",
}) => {
  const isCustom = customText !== "";
  const { disabled } = item;
  const getClassName = () => {
    const base = `${style.profile__profileItem_wrapper}`;
    const isIncompleteClass = ``;
    const redOutline =
      item.redOutline && style.profile__profileItem_incompleteMobile;
    const status = `${getStatus(item) === "hidden" ? "d-none" : "d-flex"}`;
    const classes = [base, redOutline, status, isIncompleteClass];
    return classes.join(" ");
  };

  return (
    <div
      id="profileItemNameWrapper"
      className={`rounded shadow ${getClassName()}`}
    >
      {isIncomplete && <span className={style.profile__bar} />}
      {isIncomplete && (
        <ErrorIcon className={style.profile__profileItem_icon} />
      )}
      <div
        className={`d-flex align-items-center justify-content-between w-100 ${
          style.profile__profileItem
        } ${isCustom && style.profile__profileItem_mobileHeader}`}
      >
        <div className={style.profile__profileItem_inner}>
          <span
            className={`${style.profile__profileItem_text} ${
              isCustom && style.profile__profileItem_customItem
            } ${isIncomplete && style.profile__profileItem_text_incomplete}`}
          >
            {isCustom ? (
              item.name
            ) : (
              <OverflowedText id="profileItemName" overflowedText={item.name}>
                {item.name}
              </OverflowedText>
            )}
          </span>
        </div>
        {getButtonForSection(
          item,
          isIncomplete,
          onAddOrUpdate,
          customText,
          item.redOutline,
          disabled
        )}
      </div>
    </div>
  );
};

ProfileItem.propTypes = {
  className: string,
  item: any,
  isIncomplete: bool,
  onAddOrUpdate: func,
  customText: string,
};

export default ProfileItem;
